import Vue from "vue";
import App from "./App.vue";
import VueRouter from "vue-router"; //vue路由
import router from "./router/router"; //路由配置
import md5 from "js-md5"; //md5加密
import store from "./store/store"; //vuex
import RouteTransition from "vue-route-transition"; //页面跳转动画
import { server } from "./request/api";


import { Loadmore } from 'mint-ui';

Vue.component(Loadmore.name, Loadmore);


// 标题
import vueWechatTitle from "vue-wechat-title";

Vue.config.productionTip = false;

// vant的样式
import "vant/lib/index.css";
// icon的样式
import "vant/lib/icon/local.css";
// 适配
import "amfe-flexible/index.js";
// vant组件
import { Checkbox, CheckboxGroup,Button,Icon,Loading,ActionSheet,Dialog,Uploader,Toast,PullRefresh,Popup,ImagePreview,Collapse,CollapseItem,RadioGroup,Radio,Cell,CellGroup,Picker,DatetimePicker,Area} from "vant";
import { List } from 'vant';
import moment from "moment";
import Calendar from 'vue2-datepick'; //日期控件

Vue.use(Calendar);//日期控件

//定义全局变量
Vue.prototype.$http = server; //axios请求
Vue.prototype.$md5 = md5; //md5加密
Vue.prototype.$hide = Dialog; //提示框
Vue.prototype.$toast = Toast; //轻提示

Vue.filter('dateFormat',function(dataStr,pattern = "YYYY-MM-DD HH:mm:ss"){
  return moment(dataStr).format(pattern)
})


VueRouter.prototype.goBack = function() {
  this.isBack = true;
  window.history.go(-1);
};

router.beforeEach(function(to,from,next){
  window.console.log(from)
  window.console.log(to)
  
      
  if(to.meta.needLogin){
    //页面是否登录
    if (localStorage.getItem("token")) {
      //本地存储中是否有token(uid)数据
      next(); //表示已经登录
    } else {
      //next可以传递一个路由对象作为参数 表示需要跳转到的页面
      window.console.log("来这里吗")
      next({
        name: "login"
      });
    }
  }else{
    //表示不需要登录
    next(); //继续往后走
  }
  if(from.path == '/userInfo' || from.path == '/company' || from.path == '/company'){
    localStorage.setItem("leftBox",true)
    next();
  }else{
    localStorage.removeItem("leftBox")
    next();
  }
  
})

// 路由
Vue.use(VueRouter);
// 标题
Vue.use(vueWechatTitle);

Vue.use(Button);
Vue.use(Icon);
Vue.use(Loading);
Vue.use(ActionSheet);
Vue.use(Dialog);
Vue.use(Uploader);
Vue.use(RouteTransition);
Vue.use(Toast);
Vue.use(PullRefresh);
Vue.use(List);
Vue.use(Popup);
Vue.use(ImagePreview);
Vue.use(Collapse).use(CollapseItem);
Vue.use(RadioGroup);
Vue.use(Radio);
Vue.use(Cell);
Vue.use(CellGroup);
Vue.use(Checkbox);
Vue.use(CheckboxGroup);
Vue.use(Picker);
Vue.use(DatetimePicker);
Vue.use(Area);

new Vue({
  el: "#app",
  VueRouter,
  router,
  store,
  render: h => h(App)
}).$mount("#app");
